import React, { useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Card, Image, Table, Button, Grid } from "semantic-ui-react";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import AssetStore from "../../../app/stores/assetStore";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { RootStoreContext } from "../../../app/stores/rootStore";
import KeeperForm from "./KeeperForm";

interface DetailParams {
  id: string;
}

const AssetDetails: React.FC<RouteComponentProps<DetailParams>> = ({
  match,
  history,
}) => {
  const rootStore = useContext(RootStoreContext);
  const {openModal} = rootStore.modalStore;
  const assetStore = useContext(AssetStore);
  const { asset, loadAsset, loadingInitial } = assetStore;

  useEffect(() => {
    loadAsset(match.params.id);
  }, [loadAsset, match.params.id]);

  if (loadingInitial || !asset)
    return <LoadingComponent content="Loading Asset ..." />;

  return (
    <Card fluid>
      <Card.Content>
        <Table definition fixed>
          <Table.Body>
            <Table.Row>
              <Table.HeaderCell width={3}>{asset.code}</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Asset Name</Table.Cell>
              <Table.Cell> {asset!.assetName} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Type </Table.Cell>
              <Table.Cell> {asset!.type} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Model </Table.Cell>
              <Table.Cell> {asset!.model} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Status</Table.Cell>
              <Table.Cell> {asset!.status} </Table.Cell>
            </Table.Row>
            
            <Table.Row>
              <Table.Cell>Keeper</Table.Cell>
              <Table.Cell> 
                {asset!.keep[0].keeper} 
                <Button
            onClick={() => openModal(<KeeperForm />)}
            floated='right'
            size='mini'
            color="grey"
            content="History"
          />
              </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Keep Date</Table.Cell>
              <Table.Cell> {asset!.keep[0].keepDate} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Price</Table.Cell>
              <Table.Cell> {asset!.price} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Purchase Date</Table.Cell>
              <Table.Cell> {asset!.purchaseDate} </Table.Cell>
            </Table.Row>
            
            <Table.Row>
              <Table.Cell>Service Life</Table.Cell>
              <Table.Cell> {asset!.life} </Table.Cell>
            </Table.Row>
            {(asset.type === 'Tool') && <Table.Row>
              <Table.Cell>Inspection Date</Table.Cell>
              <Table.Cell> {asset!.inspectionDate} </Table.Cell>
            </Table.Row>
            }
            {(asset.type === 'Tool') && <Table.Row>
              <Table.Cell>Inspection Frequency</Table.Cell>
              <Table.Cell> {asset!.inspectionFrequency} </Table.Cell>
            </Table.Row>
            }
            {(asset.type === 'Vehicle') && <Table.Row>
              <Table.Cell>Service Date</Table.Cell>
              <Table.Cell> {asset!.serviceDate} </Table.Cell>
            </Table.Row>}
            {(asset.type === 'Vehicle') && <Table.Row>
              <Table.Cell>Rego Date</Table.Cell>
              <Table.Cell> {asset!.regoDate} </Table.Cell>
            </Table.Row>}
            {(asset.type === 'Vehicle') && <Table.Row>
              <Table.Cell>Insurance Date</Table.Cell>
              <Table.Cell> {asset!.insuranceDate} </Table.Cell>
            </Table.Row>}
            <Table.Row>
              <Table.Cell>Remark</Table.Cell>
              <Table.Cell> {asset!.remark} </Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Photo</Table.Cell>
              <Table.Cell> 
              <Grid>
              {asset.photoUrl.map(url => ( <Grid.Column width='3'>
              <Image
                src={`/${url}`}
                size='small'
              />
              </Grid.Column>))}
              </Grid>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Card.Content>
      <Card.Content extra>
        <Button.Group widths={2}>
          <Button
            as={Link}
            to={`/dailymanagement/asset-edit/${asset.id}`}
            basic
            color="blue"
            content="Edit"
          />
          <Button
            onClick={() => history.push("/dailymanagement/asset")}
            basic
            color="grey"
            content="Cancel"
          />
        </Button.Group>
      </Card.Content>
    </Card>
  );
};

export default observer(AssetDetails);
